import React from 'react';

function Updates() {
  const updates = [
    {
      date: 'March 7, 2025',
      title: 'Improved Feedback',
      description: 'Providing post-interview insights and recommendations based on the responses.',
      type: 'major'
    },
    {
      date: 'March 1, 2025',
      title: 'Platform Governance Updates',
      description: 'Adding essential informational pages to improve clarity, user trust, and compliance with standard policies.',
      type: 'feature'
    },
    {
      date: 'Feb 17, 2025',
      title: 'Latency Optimization',
      description: 'Enhancing app performance by reducing response time and improving speed for a smoother user experience.',
      type: 'feature'
    },
    {
      date: 'Feb 5, 2025',
      title: 'UI Improvements',
      description: 'Enhanced user interface with better navigation and accessibility features.',
      type: 'improvement'
    },
    {
      date: 'Feb 1, 2025',
      title: 'Beta Launch',
      description: 'A limited release of a product for testing and feedback.',
      type: 'major'
    }
  ];

  const getTypeStyles = (type) => {
    switch (type) {
      case 'major':
        return 'bg-purple-500/10 text-purple-400';
      case 'feature':
        return 'bg-emerald-500/10 text-emerald-400';
      case 'improvement':
        return 'bg-purple-500/10 text-purple-400';
      default:
        return 'bg-gray-500/10 text-gray-400';
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0F17] text-gray-100 py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold mb-8 bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
          Latest Updates
        </h1>

        <div className="space-y-8">
          {updates.map((update, index) => (
            <div key={index} className="bg-gray-900/30 backdrop-blur-sm rounded-2xl p-6 border border-gray-800/50">
              <div className="flex items-center justify-between mb-4">
                <span className="text-sm text-gray-400">{update.date}</span>
                <span className={`px-3 py-1 rounded-full text-xs ${getTypeStyles(update.type)}`}>
                  {update.type.charAt(0).toUpperCase() + update.type.slice(1)}
                </span>
              </div>
              <h2 className="text-xl font-semibold text-white mb-3">{update.title}</h2>
              <p className="text-gray-400 leading-relaxed">{update.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button className="px-6 py-3 bg-blue-500/10 text-blue-400 rounded-lg hover:bg-blue-500/20 transition-colors">
            Load More Updates
          </button>
        </div>
      </div>
    </div>
  );
}

export default Updates; 